import { useSuiClient } from '@mysten/dapp-kit';
import { useQuery } from '@tanstack/react-query';

import { listStakePositions, type StakePositionView, type StakeQueryClient } from '@cpc/tx';

const REFETCH_MS = 30_000;

export function useCpcStakePositions(owner: string | undefined) {
	const client = useSuiClient();

	return useQuery({
		queryKey: ['cpc-stake-positions', owner],
		queryFn: () =>
			listStakePositions(client as unknown as StakeQueryClient, owner!),
		enabled: !!owner,
		refetchInterval: REFETCH_MS,
		staleTime: 15_000,
	});
}

export type { StakePositionView };
